module.exports = __webpack_public_path__ + "img/16.4c60f6fc.png";